import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AllowanceEntity,
  BokkzAlgDataService,
  BokkzTslDataService,
  BokkzTslLogic,
  ClientEntity,
  Huurtoeslag,
  Kinderopvangtoeslag,
  Kindgebondenbudget,
  Zorgtoeslag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {filter, Subject, takeUntil} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-voorschot',
  templateUrl: './voorschot.component.html',
  styleUrls: ['./voorschot.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class VoorschotComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private destroy$ = new Subject<void>();
  private clientEntity ={} as ClientEntity;
  private isSaving = false;
  public allowanceEntity = {} as AllowanceEntity;
  public zorgToeslagFg = {} as FormGroup;
  public huurToeslagFg = {} as FormGroup;
  public kotToeslagFg = {} as FormGroup;
  public kgbToeslagFg = {} as FormGroup;

  constructor(
    private router: Router,
    public tslLogic: BokkzTslLogic,
    public dataAlgService: BokkzAlgDataService,
    public dataService: BokkzTslDataService,
    private fb: FormBuilder) {
    this.zorgToeslagFg = this.fb.group<Zorgtoeslag>({
      alOntvangenZorgtoeslag: null as unknown as number,
    })
    this.huurToeslagFg = this.fb.group<Huurtoeslag>({
      huurwoningen: [],
      alOntvangenHuurtoeslag: null as unknown as number
    })
    this.kotToeslagFg = this.fb.group<Kinderopvangtoeslag>({
      aantalWerkurenPerWeekEersteOuder: 0,
      aantalWerkurenPerWeekTweedeOuder: 0,
      eersteOuderStudeert: false,
      tweedeOuderStudeert: false,
      alOntvangenKOT: null as unknown as number
    })
    this.kgbToeslagFg = this.fb.group<Kindgebondenbudget>({
      alOntvangenKGB: null as unknown as number,
    })
  }

  public ngOnInit(): void {
    this.dataService.allowanceEntity.pipe(takeUntil(this.destroy$)).subscribe((allowanceEntity) => {
      this.allowanceEntity = allowanceEntity;
      if (allowanceEntity.toeslagen) {
        if (allowanceEntity.toeslagen.zorgtoeslag !== undefined) {
          this.zorgToeslagFg.patchValue({alOntvangenZorgtoeslag: allowanceEntity.toeslagen.zorgtoeslag.alOntvangenZorgtoeslag}, {emitEvent: false})
        }
        if (allowanceEntity.toeslagen.huurtoeslag !== undefined) {
          this.huurToeslagFg.patchValue({alOntvangenHuurtoeslag: allowanceEntity.toeslagen.huurtoeslag.alOntvangenHuurtoeslag}, {emitEvent: false})
        }
        if (allowanceEntity.toeslagen.kot !== undefined) {
          this.kotToeslagFg.patchValue({alOntvangenKOT: allowanceEntity.toeslagen.kot.alOntvangenKOT}, {emitEvent: false})
        }
        if (allowanceEntity.toeslagen.kgb !== undefined) {
          this.kgbToeslagFg.patchValue({alOntvangenKGB: allowanceEntity.toeslagen.kgb.alOntvangenKGB}, {emitEvent: false})
        }
      }
    });
    this.dataAlgService.client.pipe(takeUntil(this.destroy$)).subscribe((clientEntity)=> {
      this.clientEntity=clientEntity;
    });
    this.router.events.pipe(
      takeUntil(this.destroy$),
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {this.handleUrlChange()});
  }

  saveForm(): void {
    this.kotToeslagFg.updateValueAndValidity();
    this.kgbToeslagFg.updateValueAndValidity();
    this.huurToeslagFg.updateValueAndValidity();
    this.zorgToeslagFg.updateValueAndValidity();

    this.allowanceEntity.toeslagen = {
      ...this.allowanceEntity.toeslagen,
      kot: {
        ...this.allowanceEntity.toeslagen?.kot,
        alOntvangenKOT: this.kotToeslagFg.value.alOntvangenKOT,
      },
      kgb: {
        ...this.allowanceEntity.toeslagen?.kgb,
        alOntvangenKGB: this.kgbToeslagFg.value.alOntvangenKGB,
      },
      huurtoeslag: {
        ...this.allowanceEntity.toeslagen?.huurtoeslag,
        alOntvangenHuurtoeslag: this.huurToeslagFg.value.alOntvangenHuurtoeslag,
      },
      zorgtoeslag: {
        ...this.allowanceEntity.toeslagen?.zorgtoeslag,
        alOntvangenZorgtoeslag: this.zorgToeslagFg.value.alOntvangenZorgtoeslag,
      }
    } as AllowanceEntity
    this.dataService.updateAllowanceTaxEntity(this.allowanceEntity);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleUrlChange() {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.tslLogic.postAllowances(this.clientEntity.sstRelationId!, this.allowanceEntity, false);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.zorgToeslagFg.dirty || this.kotToeslagFg.dirty || this.kgbToeslagFg.dirty || this.huurToeslagFg.dirty
  }
}
